import React, { createContext, useContext, useEffect, useState } from 'react';
import useGetAvatar from '../hooks/useGetAvatar';
import { useSelector } from 'react-redux';

const AvatarContext = createContext();

export const AvatarProvider = ({ children }) => {
  const [avatar, setAvatar] = useState(null);
  const { user } = useSelector(state => state.auth);

  const { data, loading, error, refetch } = useGetAvatar();

  useEffect(() => {
    if (user) {
      refetch();
    }
  }, [user, refetch]);

  useEffect(() => {
    if (data && data.getAvatar) {
      setAvatar(data.getAvatar);
    }
  }, [data]);

  return (
    <AvatarContext.Provider value={{ avatar, loading, error }}>{children}</AvatarContext.Provider>
  );
};

export const useAvatar = () => {
  const context = useContext(AvatarContext);
  if (!context) {
    throw new Error('useAvatar debe ser usado dentro de un AvatarProvider');
  }
  return context;
};
